import React from 'react';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import styles from '../styles/elements/Loding.module.scss';

const Loading = (props) => {
    const {message} = props;
    return (
            <Col className={`mb-5 text-center ${styles.full_screen_msg}`}>
                <Spinner animation="border" variant="success" size="lg"  /> 
                {message && <p className="mb-0">{message}</p>}
            </Col>
    );
}

export default Loading;